import {setUserSettings} from "../user.actions";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import {Grid} from "@mui/material";
import React, {useState} from "react";
import {CompRadioGroup} from "../../../components/RadioGroup";
import { getUserSettings, saveUserSettings} from "../user.actions";
import { ButtonSecondary } from "../../../components/newComponents/ButtonSecondary";
import { ButtonPrimary } from "../../../components/newComponents/ButtonPrimary";

const UserSettingsComponent = ({
                                   userSettings,
                                   authenticatedUser,
    saveUserSettings, setUserSettings,
                                   props
                               }) => {
    const {
        closeSettingsModal,
    } = props;

    const {t} = useTranslation('translation');

    const [defaultEventView, setDefaultEventView] = useState(userSettings && userSettings.defaultEventView ? userSettings.defaultEventView : "history");

    const defaultEventViewOptions = [
        {
            label: t('function.history'),
            value: "history"
        },
        {
            label: t('function.your_functions'),
            value: "your_functions"
        }
    ];

    const save = () => {

        const d = {
            "userId": authenticatedUser.id,
            "defaultEventView": defaultEventView
        }

        saveUserSettings(d, (success) => {
            props.closeSettingsModal()
            return setUserSettings(success);
        });
    }

    return (
        <form noValidate autoComplete="off" className={"user-container"}>
            <Grid container>
                <div className={'label'}>{t('user.defaultEventView')}</div>
                <CompRadioGroup
                    name="defaultEventViewOption"
                    selected={defaultEventView}
                    rows={defaultEventViewOptions}
                    onChange={(e) => setDefaultEventView(e.target.value)}/>
            </Grid>
            <Grid container>
                <Grid className={'align-right'} size={12}>
                    <ButtonSecondary onClick={closeSettingsModal}>
                        {t('common.cancel')}
                    </ButtonSecondary>
                    <ButtonPrimary onClick={save}>
                        {t('common.save')}
                    </ButtonPrimary>
                </Grid>
            </Grid>
        </form>
    );
}

const mapStateToProps = (state, ownProps) => {
    // return state;
    return {
        userSettings: state.user.userSettings,
        authenticatedUser: state.auth.authenticatedUser,
        municipalities: state.municipality.municipalities,
        organizationTree: state.municipality.organizationTree,
        userRoles: state.root.userRoles,
        props: ownProps
    }
}
const mapDispatchToProps = dispatch => {
    return {
        saveUserSettings: (data, onSuccess) => dispatch(saveUserSettings(data, onSuccess)),
        getUserSettings: () => dispatch(getUserSettings()),
        setUserSettings: (data) => dispatch(setUserSettings(data))
    };
}

const UserSettings = connect(mapStateToProps, mapDispatchToProps)(UserSettingsComponent);

export {UserSettings};